import Rete from 'rete'

import OtnTemplate from './OtnTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class OtnComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.OTN)
    
    this.data.component = OtnTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
  }

  builder(node) {
    node.lingualName = lingualName.OTN
    this.setConnection()
    
    const otnInput = new Rete.Input(CONST_SOCKET.OTN_INPUT, lang.otn_socket_input_reply, this.socket.otnInput, true)
    const otnOutput = new Rete.Output(CONST_SOCKET.OTN_OUTPUT, lang.otn_socket_output_next, this.socket.otnOutput, false)

    return node
      .addInput(otnInput)
      .addOutput(otnOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.OTN_OUTPUT] = node.data
  }

  setConnection() {
    // OTN may be connected to:
    this.socket.otnOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.otnOutput.combineWith(this.socket.openaiInput)
    this.socket.otnOutput.combineWith(this.socket.carouselInput)
    this.socket.otnOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.otnOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.otnOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.otnOutput.combineWith(this.socket.videoInput)
      this.socket.otnOutput.combineWith(this.socket.audioInput)
      this.socket.otnOutput.combineWith(this.socket.fileInput)
    }
    
    this.socket.otnOutput.combineWith(this.socket.ecommerceInput)
    this.socket.otnOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.otnOutput.combineWith(this.socket.otnSingleInput)    
    this.socket.otnOutput.combineWith(this.socket.componentListInput)    

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.otnOutput.combineWith(this.socket.userInputFlowInput)
    }
  }
}